export { ThemeContext, ThemeProvider } from "./theme-context";

export { ColorHeaderContext,ColorHeaderProvider } from "./colorHeader";

export { SearchContext, SearchProvider, useGlobalSearch } from "./SearchContext";

